import PropTypes from 'prop-types';
import React from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';

export default function Tooltip({
                                  tip,
                                  place = "top",
                                  delayShow = 1000,
                                  delayHide = 1000,
                                  html = undefined,
                                  children,
                                }) {
  const id = React.useId();

  return (
    <div
      className="tooltip-wrapper"
      data-tooltip-id={id}
      data-tooltip-content={tip}
      data-tooltip-html={html ? "true" : undefined}
      data-tooltip-place={place}
      data-tooltip-delay-show={delayShow ? 1000 : 0}
      data-tooltip-delay-hide={delayHide ? 1000 : 0}
    >
      {children}
      <ReactTooltip id={id} />
    </div>
  );
}


Tooltip.propTypes = {
  tip: PropTypes.any,
  children: PropTypes.any,
  place: PropTypes.string,
  delayShow: PropTypes.bool,
  delayHide: PropTypes.bool,
  html: PropTypes.bool,
}

Tooltip.defaultProps = {
  html: false
}
